import {CreateInstance} from './config'
const AppConfigsAPI = CreateInstance('app_configs')
export default AppConfigsAPI